import React from 'react';
import PropTypes from 'prop-types';
import { formatClassName, pickDataAttributes } from '../../../utils';
import { Checkbox } from './Checkbox/';
import { SelectionLabel } from '../../../core/components/SelectionControl/label';

export class CheckboxControl extends React.Component {
  static propTypes = {
    chakra: PropTypes.bool,
    checkboxValue: PropTypes.string,
    checked: PropTypes.bool,
    children: PropTypes.any,
    className: PropTypes.string,
    dataValue: PropTypes.bool,
    disabled: PropTypes.bool,
    hideLabel: PropTypes.bool,
    id: PropTypes.string,
    inline: PropTypes.bool,
    label: PropTypes.string,
    labelClass: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onValueChange: PropTypes.func,
    padding: PropTypes.object,
    type: PropTypes.oneOf(['checkbox', 'radio']),
    validateChange: PropTypes.func,
    valueOverride: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      checked: this.getCheckedState(props),
    };
  }

  static defaultProps = {
    type: 'checkbox',
    forceStateUpdate: false,
  };

  getCheckedState(props) {
    return props.checked || (props.dataValue === undefined || props.dataValue === 'false' ? false : props.dataValue);
  }

  componentDidUpdate(prevProps) {
    const { valueOverride, dataValue } = this.props;

    if (valueOverride && dataValue !== prevProps.dataValue) {
      this.onChange(dataValue, true);
      this.setState({ checked: Boolean(dataValue) });
    }
  }

  onChange = (checked, skipValueChange) => {
    if (checked === this.state.checked) return;

    this.setState({ checked }, () => {
      let value;
      if (this.props.checkboxValue) {
        value = checked ? this.props.checkboxValue : undefined;
      } else {
        value = checked;
      }
      // order of calling onValueChange and onChange matters
      // when checkboxControl(MaterialCheckbox) is added inside Form
      if (typeof this.props.onValueChange === 'function' && !skipValueChange) {
        this.props.onValueChange({ [this.props.name]: value });
      }
      if (typeof this.props.onChange === 'function') {
        this.props.onChange(value, skipValueChange);
      }
    });
  };

  onCheckChange = event => {
    if (typeof this.props.validateChange === 'function') {
      const performChange = this.props.validateChange(event.currentTarget.checked);
      if (!performChange) {
        event.preventDefault();
        event.stopPropagation();
        event.currentTarget.checked = false;
        return;
      }
    }
    this.onChange(event.currentTarget.checked);
  };

  render() {
    const {
      chakra,
      checkboxValue,
      children,
      className,
      disabled,
      hideLabel,
      id: propId,
      inline,
      label,
      labelClass,
      name,
      padding,
      type,
    } = this.props;
    const { checked } = this.state;
    const id = propId || name;
    const checkClassName = formatClassName([
      className,
      { 'checkbox-inline': inline && type === 'checkbox' },
      { disabled },
      { 'radio-inline': inline && type === 'radio' },
    ]);

    return (
      <Checkbox
        {...pickDataAttributes(this.props)}
        chakra={chakra}
        checkClassName={checkClassName}
        id={id}
        hideLabel={hideLabel}
        isChecked={checked}
        isDisabled={disabled}
        labelAction="checkbox"
        name={name}
        onChange={this.onCheckChange}
        padding={padding}
        type={type}
        value={checkboxValue || String(checked)}
      >
        <>
          <SelectionLabel label={children || label} className={labelClass} />
          {checkboxValue ? null : <input type="hidden" name={name} value="false" disabled={checked} />}
        </>
      </Checkbox>
    );
  }
}
